<template>
  <roe-error-message :field="design.age_requirement_years">
    <input
      type="number"
      v-model.number="design.$model.age_requirement_years"
      required
      min="0"
      @change="updateRequirementConnectedModels()"
    />
    <label class="input-label-inside">years</label>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
export default {
  name: "RoeAgeRequirementYearsInput",
  components: { RoeErrorMessage },
  props: {
    design: Object
  },
  methods: {
    updateRequirementConnectedModels() {
      if (
          (+this.design.$model.age_requirement_employer_match === 1 &&
              +this.design.$model.age_requirement_employee_deferrals !== 0) ||
          +this.design.$model.age_requirement_sync === 1
      ) {
        this.design.$model.age_requirement_match_years = this.design.$model.age_requirement_years;
      }

      if (+this.design.$model.age_requirement_profit_sharing === 1) {
        this.design.$model.age_requirement_profit_sharing_years = this.design.$model.age_requirement_years;
      }
    }
  }
};
</script>
